module.exports = __webpack_public_path__ + "img/ActionTargetLogoSmall.fa087b26.png";